module.exports = {
    columnSorting: { indicator: true },
    fixedColumnsLeft: 1,
    headerTooltips: {
        rows: false,
        columns: true,
        onlyTrimmed: false,
    },
    licenseKey: 'non-commercial-and-evaluation',
    rowHeaders: true,
    readOnly: true,
    readOnlyCellClassName: '',
    wordWrap: false,
};
